import React, {PropTypes} from 'react';

const AuditVirtualEntryHeader = ({
  virtualEventName,
  captainName,
  bowlerName,
  tournamentName
}) => {
  return (
  <div className="list-group-item-labeled"> 
  <div className="list-group-item-labeled-child"
    style={{width: 250}}>
    <span>{'Virtual Event'}</span>
    <span>{virtualEventName}</span>
  </div> 
    <div className="list-group-item-labeled-child"
      style={{width: 150}}>
      <span>{'Captain'}</span>
      <span>{captainName}</span>
    </div>   
    <div className="list-group-item-labeled-child"
      style={{width: 150}}>
      <span>{'Bowler'}</span>
      <span>{bowlerName}</span>
    </div>   
    <div className="list-group-item-labeled-child"
      style={{width: 250}}>
      <span>{'Tournament'}</span>
      <span>{tournamentName}</span>
    </div>   
  </div>
  );  
};

AuditVirtualEntryHeader.propTypes = {
  virtualEventName: PropTypes.string,
  captainName: PropTypes.string,
  bowlerName: PropTypes.string,
  tournamentName: PropTypes.string 
};

AuditVirtualEntryHeader.defaultProps = {
};

export default AuditVirtualEntryHeader;



// WEBPACK FOOTER //
// ./src/features/admin/audit/virtualEntryAudit/AuditVirtualEntryHeader.jsx